/**
 * Which DEMA-WMA strategy the DEMA-WMA page and its panels talk to: the original (default) or the independent
 * Enhanced DEMA-WMA Gainer v33. Every panel calls `useDemaWmaService()` instead of importing one fixed client.
 */
import { createContext, useContext } from "react";
import demaWmaGainerService, { type DemaWmaGainerServiceApi } from "@/services/demaWmaGainerService";

export const DemaWmaServiceContext = createContext<DemaWmaGainerServiceApi>(demaWmaGainerService);

export function useDemaWmaService(): DemaWmaGainerServiceApi {
  return useContext(DemaWmaServiceContext);
}
